import styles from '../../styles';
import { translate } from '../../locales/i18n';

const ConsumerMenuItems = (user) => ({
  style: styles.nav.avatarContainerConsumer,
  modeSwitchText: translate('menu_mode_publisher'),
  modeSwitchLink: (user && user.attributes) ? `/publisher/${user.attributes.sub}` : '/my-ai-agents',
  mainMenuItems: [
    ...(user == null ? [
      {
        text: translate('menu_home'),
        link: '/',
      },
    ] : []),
    {
      text: translate('menu_find_apps'),
      link: '/ai-agents',
    },
    ...(user != null ? [
      {
        text: translate('menu_my_apps'),
        link: '/saved-ai-agents',
      },
      {
        text: translate('menu_settings'),
        link: '/settings',
      },
    ] : []),
  ],
  collapsableMenuItems: [
    {
      text: translate('menu_help'),
      stateName: 'isHelpExpanded',
      items: [
        {
          text: translate('menu_faq'),
          link: '/help',
        },
        {
          text: translate('menu_support'),
          link: '/support',
        },
      ],
    },
    {
      text: translate('menu_aionrails'),
      stateName: 'isAboutExpanded',
      items: [
        {
          text: translate('menu_project_info'),
          link: '/about',
        },
        {
          text: translate('menu_company_info'),
          link: '/aboutus',
        },
        {
          text: translate('menu_careers'),
          link: '/careers',
        },
        // {
        //   text: translate('menu_investors'),
        //   link: '/investors',
        // },
        {
          text: translate('menu_legal'),
          link: '/legal',
        },
        {
          text: translate('menu_privacy'),
          link: '/privacy',
        },
        {
          text: translate('menu_contact'),
          link: '/contact',
        },
      ],
    },
  ],
});

export default ConsumerMenuItems;
